import { InsightsPageTemplate } from "@/components/templates/InsightsPageTemplate";
import { aiAgentsCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiAgentsCluster.insightPages.find(p => p.slug === "what-are-ai-agents")!;
const relatedMoney = getRelatedMoneyPages("ai-agents").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-agents").map(p => ({ title: p.title, slug: p.slug }));

export default function WhatAreAIAgentsPage() {
  return (
    <InsightsPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
